"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { captureAttributionFromUrl, captureFbcFromUrl, readAttribution } from "@/lib/attribution";
import { registerAttributionForPostHog, registerSharedPostHogProperties, trackPageView } from "@/lib/posthog";

export function PostHogPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams.toString();

  // PostHog init itself is deferred to interaction/idle (DeferredThirdParty);
  // the calls below queue via onPostHogReady, so no pageview is lost.
  useEffect(() => {
    captureAttributionFromUrl(window.location.search);
    captureFbcFromUrl(window.location.search);
    registerSharedPostHogProperties();
    registerAttributionForPostHog(readAttribution());
    trackPageView(pathname, search);
  }, [pathname, search]);

  return null;
}